import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Clock, Home, LogOut, Wrench } from "lucide-react";
import { ROUTES, APP_SHORT_NAME } from "@/config/constants";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/utils/cn";

const NAV = [
  { to: ROUTES.OPERADOR, label: "Início", icon: Home, end: true },
  { to: ROUTES.OPERADOR_HORIMETRO, label: "Horímetro", icon: Clock, end: false },
  { to: ROUTES.OPERADOR_MANUTENCAO, label: "Manutenção", icon: Wrench, end: false },
] as const;

export function OperadorLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  return (
    <div className="flex h-dvh flex-col bg-slate-50">
      <header className="flex flex-shrink-0 items-center justify-between border-b border-slate-200 bg-white px-4 py-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">{APP_SHORT_NAME}</p>
          <h1 className="truncate text-base font-bold text-slate-800">App do Operador</h1>
        </div>
        <div className="flex items-center gap-2">
          <span className="hidden max-w-[8rem] truncate text-xs text-slate-500 sm:inline">
            {user?.displayName}
          </span>
          <button
            type="button"
            onClick={() => void handleLogout()}
            className="rounded-lg p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700"
            aria-label="Sair"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto p-4 pb-24">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white px-2 pb-[env(safe-area-inset-bottom)]">
        <ul className="mx-auto flex max-w-lg items-stretch justify-around">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <li key={to} className="flex-1">
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) =>
                  cn(
                    "flex flex-col items-center gap-0.5 px-2 py-3 text-xs font-medium transition-colors",
                    isActive ? "text-brand-600" : "text-slate-500 hover:text-slate-700",
                  )
                }
              >
                <Icon className="h-5 w-5" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
